import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { FileHelper, GuidHelper, IdHelper } from '@osapp/helpers';
import { EPrefix, IGalleryFile } from '@osapp/model';
import { DmsFile } from '@osapp/modules/dms/model/DmsFile';
import { LongGuidBuilder } from '@osapp/modules/guid/models/long-guid-builder';
import { ContactsService } from '@osapp/services';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { finalize } from 'rxjs/operators';
import { ITransmissionRapport } from '../../../../../modules/patients/model/ITransmissionRapport';
import { RapportService } from '../../../../../modules/patients/services/rapport.service';
import { ICommentaireTransmission } from '../../../../models/ICommentaireTransmission';
import { LoaderService } from '../../../shared/services/loader.service';
import { PanneauService } from '../../../shared/services/panneau.service';
import { TransmissionService } from '../../../shared/services/transmission.service';

export interface ControlConfig {
  name: string;
  value: any;
  validators?: ValidatorFn[] | ValidatorFn;
}

@Component({
  selector: 'di-panneau-comment-transmission',
  templateUrl: './panneau-comment-transmission.component.html',
  styleUrls: ['./panneau-comment-transmission.component.scss'],
})
export class PanneauCommentTransmissionComponent implements OnInit {

  public patient: IPatient;
	@Input() public transmission : ITransmissionRapport;
	@Input() public comment? : ICommentaireTransmission;
	@Input() public openDoc? : boolean;

	public model : ICommentaireTransmission;
	public listDoc : IGalleryFile[] = [];
	public listNewFile : File[] = [];

	public commentForm: FormGroup;
	public errorMessage : string = "Le fichier sélectionné est trop volumineux (5Mo maximum)";;
	public isError : boolean = false;

	public transmissionControlsConfig: ControlConfig[];
	private readonly guidBuilder = new LongGuidBuilder();



  constructor(
    private svcPanneau: PanneauService,
		private svcTransmission: TransmissionService,
		private fb: FormBuilder,
		private svcLoader : LoaderService,
		private svcRapport: RapportService,
		
		) { }

  ngOnInit() {

		if (this.transmission && this.comment) {
			this.model = this.comment;
			this.listDoc = [...this.comment.files];
		}

		this.transmissionControlsConfig = [
			{ name: 'description', value: this.model ? this.model.description : '' }
    ];

		this.commentForm = this.fb.group({});
      this.transmissionControlsConfig.forEach(control => {
        this.commentForm.addControl(
          control.name,
          this.fb.control(control.value, control.validators || [])
        );
      });
  }

	public handleSubmit(event: Event): void {
    event.preventDefault();
    if (this.commentForm.valid) {
      const formValues = this.commentForm.value;
      let formComment = {}
      if (this.model) {
        formComment = { ...this.model }
      } else {
        formComment = {
          id: ''
        }
      }
      formComment = {
        ...formComment,
        ...formValues
      }
			this.createOrUpdateComment(formComment);
		}
  }

	public deleteNewFile(event:File):void{
		const index = this.listNewFile.findIndex(file =>
			file.name === event.name &&
			file.size === event.size &&
			file.type === event.type
		);
		
		if (index !== -1) {
			this.listNewFile.splice(index, 1);
		}	
	}

	public deleteOldFile(event:IGalleryFile):void{
		const index = this.listDoc.findIndex(file =>
			file.guid === event.guid
		);
		
		if (index !== -1) {
			this.listDoc.splice(index, 1);
		}	
	}

	public async handleFileSelected(file: File) {
		if (file) {
			if (file.size > 1000 * 1024) {
				try {
						const newFile: File = await FileHelper.resizeImageAnakn(file);
						this.listNewFile.push(newFile);
				} catch (error) {
						this.isError = true;
						console.error('Error resizing file:', error);
				}			
			}
			else
			{
				this.isError = false;
				this.listNewFile.push(file);
			}
		}
	}

	private createOrUpdateComment(commentValue :any)
	{
		this.svcLoader.showLoader("Sauvegarde de la transmission en cours...");
		if(commentValue.id === '')
		{
			let comment:ICommentaireTransmission =
			{
				id : GuidHelper.newGuid(),
				auteurId:ContactsService.getUserContactId(),
				dateCreation:new Date(),
				dateLastModification:new Date(),
				description:commentValue.description,
				files : []
			}

			this.listNewFile.map((file :File) =>
			{
				const dmsFile: DmsFile = new DmsFile(file, file.name);
				const galleryFile: IGalleryFile = {
					file: dmsFile,
					isNew: true,
					name: dmsFile.Name,
					description: "",
					guid: this.guidBuilder.build({ withHyphens: false, upperCase: false })
				};
				this.listDoc.push(galleryFile);
			});

			comment.files = this.listDoc;
			
			if(!this.transmission.commentaires)
				this.transmission.commentaires = new Array<ICommentaireTransmission>();
			this.transmission.commentaires.push(comment);
		}
		else
		{
			
			const index = this.transmission.commentaires.findIndex(
				(comment: ICommentaireTransmission) => comment.id === this.model.id
			);

			if (index !== -1) {

				this.listNewFile.map((file :File) =>
					{
						const dmsFile: DmsFile = new DmsFile(file, file.name);
						const galleryFile: IGalleryFile = {
							file: dmsFile,
							isNew: true,
							name: dmsFile.Name,
							description: "",
							guid: this.guidBuilder.build({ withHyphens: false, upperCase: false })
						};
						this.listDoc.push(galleryFile);
					});
					this.listNewFile = [];


				this.transmission.commentaires[index] = {
						...this.transmission.commentaires[index],
						description: commentValue.description,
						dateLastModification: new Date(),
						files : this.listDoc
				}
			}
		}
		this.transmission.dateLastModification = new Date(),
		this.svcRapport.saveTransmissionANAKIN(this.transmission)
		.pipe(
					finalize(() => {
						this.svcPanneau.close();
						this.svcLoader.hideLoader();
					})
				).subscribe({
			next: () => {
				this.svcTransmission.triggerRefreshTransmissionList();
				this.svcPanneau.close();
			},
			error: (error) => {
			}
		});
	}


	public getIdPatient(string:string) : string{
		return `${EPrefix.patient}${IdHelper.getGuidFromId(string, EPrefix.patient).split(IdHelper.C_ID_SEPARATOR)[0]}`;
	}

	public close(){
		this.svcPanneau.close();
	}
}